import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import Gap from 'bloko/blocks/gap';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import Nav from 'components/Admin/Nav/Nav';
import ActsSummaryReportBody from 'components/Admin/Reports/ActsSummaryReport/';

const ActsSummaryReport = () => (
    <>
        <AdminHeader />
        <ColumnsWrapper>
            <ColumnsRow>
                <Column xs="4" s="8" m="12" l="16">
                    <Gap top bottom>
                        <Nav />
                        <ActsSummaryReportBody />
                    </Gap>
                </Column>
            </ColumnsRow>
        </ColumnsWrapper>
    </>
);

export default ActsSummaryReport;
